import { render } from "./AStat.vue?vue&type=template&id=6595c5aa&scoped=true"
import script from "./AStat.vue?vue&type=script&lang=js"
export * from "./AStat.vue?vue&type=script&lang=js"

import "./AStat.vue?vue&type=style&index=0&id=6595c5aa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6595c5aa"]])

export default __exports__